import { call, fork, select, take, takeEvery } from 'redux-saga/effects';

import { fetchSystem } from '../api';
import { navigateToNextStep } from '../helper';
import { getNavigate } from '../../navigationService';

import { systemActions } from './actions';
import { getSystemById } from './selectors';
import { SYSTEM_ID_NEXT_ASSESSMENT } from '../constants';

export function* loadSystem({payload}) {
  const { systemId } = payload;

  const system = yield select(getSystemById, systemId);

  if (system.isNew || systemId === SYSTEM_ID_NEXT_ASSESSMENT)
    yield call(fetchSystem, systemId);
}

export function* watchFetchSystemSuccess() {
  while (true) {
    const { payload } = yield take(systemActions.FETCH_SYSTEM_SUCCESS);

    if (payload.systemId === SYSTEM_ID_NEXT_ASSESSMENT) {
      const navigate = getNavigate();
      navigateToNextStep(payload.data, navigate);
    }
  }
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadSystem() {
  yield takeEvery(systemActions.LOAD_SYSTEM, loadSystem);
}

//=====================================
//  ROOT
//-------------------------------------

export const systemSagas = [
  fork(watchLoadSystem),
  fork(watchFetchSystemSuccess),
];
